import styled from '@emotion/styled'

export const TableFrame = styled.div`
  border: 1px solid var(--kt-gray-200, #eff2f5);
  border-radius: 12px;
  overflow: hidden;
  background: var(--kt-body-bg, #fff);
  .report-table-scroll {
    overflow: auto;
    max-height: max(280px, calc(100vh - 330px));
    scrollbar-width: thin;
    scrollbar-color: var(--kt-gray-300, #e4e6ef) transparent;
  }
  .report-table-scroll:focus-visible {
    outline: 2px solid var(--kt-primary, #009ef7);
    outline-offset: -2px;
  }
  table {
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    min-width: 100%;
    font-size: 13px;
    color: var(--kt-gray-700, #5e6278);
  }
  table.has-custom-widths {
    min-width: 0;
  }
  th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--kt-gray-100, #f9f9f9);
    border-bottom: 1px solid var(--kt-gray-300, #e4e6ef);
    text-align: left;
    padding: 0;
    font-weight: 600;
  }
  th[aria-sort='ascending'],
  th[aria-sort='descending'] {
    color: var(--kt-primary, #009ef7);
    background: var(--kt-primary-light, #f1faff);
  }
  .column-sort {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 14px 18px;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: inherit;
    min-height: 48px;
  }
  .column-sort span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .column-sort svg {
    flex-shrink: 0;
    opacity: 0.6;
  }
  .column-sort:hover,
  .column-sort:focus-visible {
    color: var(--kt-primary, #009ef7);
  }
  .column-sort:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: -3px;
  }
  .column-resizer {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 9px;
    cursor: col-resize;
    touch-action: none;
    z-index: 3;
  }
  .column-resizer::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 13px;
    bottom: 13px;
    width: 1px;
    background: var(--kt-gray-300, #e4e6ef);
  }
  .column-resizer:hover::after,
  .column-resizer:focus-visible::after,
  .column-resizer.is-resizing::after {
    width: 3px;
    background: var(--kt-primary, #009ef7);
  }
  .column-resizer:focus-visible {
    outline: 2px solid var(--kt-primary, #009ef7);
    outline-offset: -2px;
  }
  td {
    padding: 12px 18px;
    height: 44px;
    border-bottom: 1px solid var(--kt-gray-200, #eff2f5);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
  tr:last-of-type td {
    border-bottom: 0;
  }
  tbody tr:nth-of-type(even) {
    background: var(--kt-gray-100, #f9f9f9);
  }
  tbody tr:hover {
    background: var(--kt-primary-light, #f1faff);
  }
  .number-cell {
    text-align: right;
  }
  .table-notes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 11px 16px;
    border-top: 1px solid var(--kt-gray-200, #eff2f5);
    color: var(--kt-gray-600, #7e8299);
    font-size: 12px;
  }
  .table-notes p {
    margin: 0;
  }
  .table-notes .btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    padding: 6px 10px;
  }
`
